module.exports = __webpack_public_path__ + "static/aisweden_grey-2b4c01206d7a8e3f74fa038568692a53.png";